import { SmartObjectSimplePlaceholder as SmartObjectSimplePlaceholderBase } from '@max/tiptap-extensions'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import SmartObjectSimplePlaceholderNodeView from '@/components/editor/SmartObjectSimplePlaceholderNodeView'

export const SmartObjectSimplePlaceholder = SmartObjectSimplePlaceholderBase.extend({
    addNodeView () {
        return VueNodeViewRenderer(SmartObjectSimplePlaceholderNodeView)
    },
})
